import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import MallNavbar from './components/MallNavbar';
import MallHeroSection from './components/MallHeroSection';
import MallIntroSection from './components/MallIntroSection';
import MallZonesSection from './components/MallZonesSection';
import MallGuideSection from './components/MallGuideSection';
import MallFeaturedSection from './components/MallFeaturedSection';
import MallLogisticsSection from './components/MallLogisticsSection';
import MallEarthSection from './components/MallEarthSection';
import MallSpaceSection from './components/MallSpaceSection';
import MallFooterSection from './components/MallFooterSection';
import MallAuthModal, { MallUser } from './components/MallAuthModal';

export default function OmniverseMallPage() {
  const navigate = useNavigate();
  const [lang, setLang] = useState<'zh' | 'en'>('zh');
  const [cartCount, setCartCount] = useState(0);
  const [user, setUser] = useState<MallUser | null>(null);
  const [showAuth, setShowAuth] = useState(false);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'NEXUS OMNI MALL · 星际元宇宙商城 | META66';
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const pts: { x: number; y: number; vx: number; vy: number; r: number; c: string; a: number }[] = [];
    const colors = ['rgba(255,215,0,', 'rgba(255,107,157,', 'rgba(0,255,204,', 'rgba(255,107,53,', 'rgba(168,85,247,'];
    for (let i = 0; i < 80; i++) {
      pts.push({ x: Math.random() * canvas.width, y: Math.random() * canvas.height, vx: (Math.random() - 0.5) * 0.25, vy: (Math.random() - 0.5) * 0.25, r: Math.random() * 1.8 + 0.3, c: colors[i % 5], a: Math.random() * 0.25 + 0.04 });
    }
    let id: number;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pts.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = canvas.width; if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height; if (p.y > canvas.height) p.y = 0;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `${p.c}${p.a})`; ctx.fill();
      });
      id = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ background: '#010208', fontFamily: "'Inter', 'PingFang SC', sans-serif" }}>
      <canvas ref={canvasRef} className="fixed inset-0 pointer-events-none z-0" />
      <MallNavbar lang={lang} setLang={setLang} cartCount={cartCount} navigate={navigate} user={user} onLoginClick={() => setShowAuth(true)} />
      <MallHeroSection lang={lang} navigate={navigate} />
      <MallIntroSection lang={lang} />
      <MallZonesSection lang={lang} navigate={navigate} />
      <MallGuideSection lang={lang} navigate={navigate} />
      <MallFeaturedSection lang={lang} navigate={navigate} cartCount={cartCount} setCartCount={setCartCount} />
      <MallLogisticsSection lang={lang} />
      <MallEarthSection lang={lang} user={user} onLoginClick={() => setShowAuth(true)} />
      <MallSpaceSection lang={lang} />
      <MallFooterSection lang={lang} navigate={navigate} />
      {showAuth && <MallAuthModal lang={lang} onClose={() => setShowAuth(false)} onLogin={(u) => { setUser(u); setShowAuth(false); }} />}
    </div>
  );
}
